import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import App from './App';
import { SharePage } from './components/sharing';

export const AppRouter: React.FC = () => {
  return (
    <Routes>
      {/* Share route - must be before the catch-all */}
      <Route path="/share/:shortCode" element={<SharePage />} />
      
      {/* Game join route */}
      <Route path="/game/join/:roomId" element={<App />} />
      
      {/* Main app route - catches all other paths */}
      <Route path="/*" element={<App />} />
    </Routes>
  );
};